/**
 * Almikia Epic E3b (TASK-066/071) -- the export contract shared by both data
 * providers. See `ADR-ee2f59a9-TASK-066-server-side-export-enforcement.md`:
 * only these resources have a matching `export_<resource>()` RPC
 * (`private.enforce_export_role()` gated to direccion/lead_manager/
 * administracion); every other resource (tags, tasks, notes, developers,
 * projects, units) is out of the owner's export scope and keeps its
 * existing REST read even when `meta.export` is set. `deal_profiles` was
 * added by Almikia Epic EF (TASK-117, DATA CONTRACT EF (7)): the leads CSV
 * appends its `profile_*` columns via the same generic export path.
 */
const EXPORTABLE_RESOURCES = [
  "contacts",
  "companies",
  "deals",
  "clients",
  "sales",
  "deal_profiles",
  // Almikia Epic EG (TASK-043): `export_expenses()` is gated to the four
  // expense roles by `private.enforce_expenses_export_role()`, not by
  // `enforce_export_role()` (see `canAccess`).
  "expenses",
] as const;

export type ExportableResource = (typeof EXPORTABLE_RESOURCES)[number];

/**
 * True when the caller flagged this read as a CSV export (set by
 * `ExportButton` / `useBulkExport` -- see the ADR referenced above), so the
 * data provider must route it through the export path instead of a plain
 * list/bulk read.
 */
export const isExportRequest = (meta: unknown): boolean =>
  typeof meta === "object" &&
  meta !== null &&
  (meta as { export?: unknown }).export === true;

/** True when `resource` has a matching `export_<resource>()` RPC. */
export const isExportResource = (
  resource: string,
): resource is ExportableResource =>
  (EXPORTABLE_RESOURCES as readonly string[]).includes(resource);
